import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Button } from 'antd';
import { Form as ReduxForm } from 'react-redux-form';

import { submitProfile } from 'modules/profile';
import Input from 'components/Fields/Input';

const FormItem = Form.Item;

const validatePhone = v => !v || v.match(/^[0-9]{10}$/);

export class Profile extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    onSubmit () {},
  };

  submit = values => {
    const { user: { email, uuid }, submitProfile: submitProfileAction, onSubmit } = this.props;
    onSubmit(values);
    submitProfileAction(email, values, uuid);
  }

  render () {
    const { form } = this.props;
    const { submit } = this;

    return (
      <ReduxForm
        model="profile.properties"
        onSubmit={submit}
      >
        <FormItem>
          <Input
            model=".lastName"
            label="Nom"
            errorMessages={{ required: { message: 'Indiquez votre nom' } }}
          />
        </FormItem>

        <FormItem>
          <Input
            model=".firstName"
            label="Prénom"
            errorMessages={{ required: { message: 'Indiquez votre prénom' } }}
          />
        </FormItem>

        <FormItem>
          <Input
            model=".phone"
            label="Téléphone"
            errorMessages={{
              required: { message: 'Indiquez votre numéro de téléphone' },
              format: {
                message: 'Veuillez respecter le format (0123456789)',
                rule: validatePhone,
              },
            }}
          />
        </FormItem>

        <Button
          type="primary"
          htmlType="submit"
          icon="arrow-right"
          loading={form.pending}
          disabled={!form.valid}
        >
          Enregistrer
        </Button>
      </ReduxForm>
    );
  }
}

const mapStateToProps = state => ({
  form: state.forms.profile.$form,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  submitProfile,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile/Staff/Profile.js